{
  "pt": {
    "ai": {
      "settings": {
        "title": "Definições de IA",
        "description": "Configuração das funcionalidades de IA no seu espaço de trabalho.",
        "budget": {
          "title": "Orçamento mensal",
          "description": "Limite mensal de custo para utilização de IA (fase de teste). Recalculado com base no consumo de tokens em todas as conversas deste mês.",
          "budget_label": "Orçamento",
          "usage_label": "Utilizado este mês",
          "save": "Guardar"
        }
      },
      "assistant": {
        "name": "Ziggy",
        "all_projects": "Todos os projetos",
        "empty_state": {
          "title": "Como posso ajudá-lo?",
          "subtitle": "Pergunte-me qualquer coisa sobre os seus clientes"
        },
        "suggestions": {
          "open_decisions": "Quais decisões ainda estão em aberto?",
          "unassigned_units": "Quais units ainda não têm cliente?",
          "help_notifications": "Como configuro as notificações?",
          "help_project_settings": "Onde encontro as definições do projeto?"
        },
        "input": {
          "placeholder": "Pergunte sobre os seus clientes...",
          "hint": "Enter para enviar · Shift+Enter para nova linha",
          "disclaimer": "Os resultados podem ser imprecisos. Verifique sempre as informações importantes."
        },
        "errors": {
          "generic": "Algo correu mal. Por favor, tente novamente.",
          "budget_reached": "Atingiu-se o orçamento mensal do assistente IA para este espaço. Contacte um administrador para aumentar o limite."
        },
        "cap": {
          "message": "Atingiu o limite de conversa.",
          "action": "Iniciar uma nova conversa"
        },
        "history": {
          "title": "Conversas anteriores",
          "empty": "Ainda não há conversas anteriores"
        },
        "support_cta": {
          "prompt": "Não era a resposta que procurava?",
          "action": "Contactar o suporte"
        }
      }
    }
  }
}
